import { z } from 'zod';

export type ServiceError =
  | { kind: 'QueryError'; message?: string | null; errorCode?: string | null }
  | { kind: 'NetworkingError'; message?: string | null; errorCode?: string | null }
  | { kind: 'InvalidData'; message?: string | null; errorCode?: string | null }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  | { kind: 'ServerError'; message?: string | null; errorCode?: string | null; data?: any };

export const ServerErrorOneSchema = z.object({
  errors: z.object({ detail: z.string() }),
});
export type ServerErrorOne = z.infer<typeof ServerErrorOneSchema>;

export const ServerErrorTwoSchema = z.object({
  message: z.string(),
  errorCode: z.union([z.string(), z.number()]).nullish().optional(),
});

export type ServerErrorTwo = z.infer<typeof ServerErrorTwoSchema>;

export type ClientItemPath = 'bought-items' | 'sold-items' | 'listed-items' | 'other-items';

export type PaginationResponse<D> = { data: D[]; total: number };
